import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import moment from 'moment';
import { getTimeArrayFromRangeKey } from './pickerParseRangeValues';
export default {
  name: 'CoreDateTimePickerFlatTextbased',
  props: {
    from: {
      type: Number,
      default: null,
      required: false
    },
    to: {
      type: Number,
      default: null,
      required: false
    },
    allowNull: {
      type: Boolean,
      default: false,
      required: false
    },
    dense: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    isRange: {
      type: Boolean,
      default: false,
      required: false
    },
    initialRange: {
      type: String,
      default: 'now-10m'
    },
    plainDates: {
      type: Boolean,
      default: false,
      required: false
    },
    dateOnly: {
      type: Boolean,
      default: false,
      required: false
    },
    futureRange: {
      type: Boolean,
      default: false,
      required: false
    },
    defaultExpand: {
      type: Boolean,
      default: false,
      required: false
    },
    hideBorderOnCollapse: {
      type: Boolean,
      default: false,
      required: false
    },
    alternateInitialText: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function data() {
    return {
      expanded: [],
      menu: false,
      hideAlternateText: false,
      startDate: null,
      endDate: null,
      pickedDisplayText: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    mathOp: function mathOp() {
      return this.futureRange ? '+' : '-';
    },
    expansionPanelsClass: function expansionPanelsClass() {
      return this.hideBorderOnCollapse ? '' : 'kpi-card-text-01';
    },
    displayText: function displayText() {
      if (this.alternateInitialText !== '' && !this.hideAlternateText) {
        return this.alternateInitialText;
      }

      return this.pickedDisplayText;
    },
    relativeRangeTextSelection: function relativeRangeTextSelection() {
      var _this = this;

      return [5, 10, 30].map(function (count) {
        return {
          count: count,
          momentQuery: "now".concat(_this.mathOp).concat(count, "m"),
          text: _this.$i18n_tc("Core.DateTimePicker.rangeItems.relative.".concat(_this.futureRange ? 'next' : 'last', "Minutes"), count, {
            n: count
          })
        };
      }).concat([1, 2, 6, 12, 24].map(function (count) {
        return {
          count: count,
          momentQuery: "now".concat(_this.mathOp).concat(count, "h"),
          text: _this.$i18n_tc("Core.DateTimePicker.rangeItems.relative.".concat(_this.futureRange ? 'next' : 'last', "Hours"), count, {
            n: count
          })
        };
      })).concat([2, 7, 14, 30].map(function (count) {
        return {
          count: count,
          momentQuery: "now".concat(_this.mathOp).concat(count, "d"),
          text: _this.$i18n_tc("Core.DateTimePicker.rangeItems.relative.".concat(_this.futureRange ? 'next' : 'last', "Days"), count, {
            n: count
          })
        };
      })).concat([6].map(function (count) {
        return {
          count: count,
          momentQuery: "now".concat(_this.mathOp).concat(count, "M"),
          text: _this.$i18n_tc("Core.DateTimePicker.rangeItems.relative.".concat(_this.futureRange ? 'next' : 'last', "Months"), count, {
            n: count
          })
        };
      })).concat([1, 2, 5].map(function (count) {
        return {
          count: count,
          momentQuery: "now".concat(_this.mathOp).concat(count, "y"),
          text: _this.$i18n_tc("Core.DateTimePicker.rangeItems.relative.".concat(_this.futureRange ? 'next' : 'last', "Years"), count, {
            n: count
          })
        };
      }));
    },
    relativeSingleTextSelection: function relativeSingleTextSelection() {
      var _this2 = this;

      var timePrefix = this.plainDates ? 'plain' : this.futureRange ? 'in' : 'past';
      return [5, 15, 30].map(function (count) {
        return {
          count: count,
          momentQuery: "now".concat(_this2.mathOp).concat(count, "m"),
          text: _this2.$i18n_tc("Core.DateTimePicker.rangeItems.relative.".concat(timePrefix, "Minutes"), count, {
            n: count
          })
        };
      }).concat([1, 2, 3, 12, 24].map(function (count) {
        return {
          count: count,
          momentQuery: "now".concat(_this2.mathOp).concat(count, "h"),
          text: _this2.$i18n_tc("Core.DateTimePicker.rangeItems.relative.".concat(timePrefix, "Hours"), count, {
            n: count
          })
        };
      })).concat([2, 7, 14, 30].map(function (count) {
        return {
          count: count,
          momentQuery: "now".concat(_this2.mathOp).concat(count, "d"),
          text: _this2.$i18n_tc("Core.DateTimePicker.rangeItems.relative.".concat(timePrefix, "Days"), count, {
            n: count
          })
        };
      })).concat([3, 6].map(function (count) {
        return {
          count: count,
          momentQuery: "now".concat(_this2.mathOp).concat(count, "M"),
          text: _this2.$i18n_tc("Core.DateTimePicker.rangeItems.relative.".concat(timePrefix, "Months"), count, {
            n: count
          })
        };
      })).concat([1, 2, 5].map(function (count) {
        return {
          count: count,
          momentQuery: "now".concat(_this2.mathOp).concat(count, "y"),
          text: _this2.$i18n_tc("Core.DateTimePicker.rangeItems.relative.".concat(timePrefix, "Years"), count, {
            n: count
          })
        };
      }));
    }
  }),
  watch: {
    initialRange: function initialRange() {
      this.startDate = parseInt(this.from, 10) || (this.allowNull ? null : getTimeArrayFromRangeKey(this.initialRange)[0]);
      this.endDate = parseInt(this.to, 10) || (this.allowNull ? null : getTimeArrayFromRangeKey(this.initialRange)[1]);
    },
    from: function from() {
      this.startDate = parseInt(this.from, 10) || (this.allowNull ? null : getTimeArrayFromRangeKey(this.initialRange)[0]);
    },
    to: function to() {
      this.endDate = parseInt(this.to, 10) || (this.allowNull ? null : getTimeArrayFromRangeKey(this.initialRange)[1]);
    },
    defaultExpand: function defaultExpand() {
      this.expanded = this.defaultExpand ? 0 : [];
    }
  },
  mounted: function mounted() {
    this.startDate = parseInt(this.from, 10) || null;
    this.endDate = parseInt(this.to, 10) || null;
    this.expanded = this.defaultExpand ? 0 : [];
    this.init();
  },
  methods: {
    getExpandIcon: function getExpandIcon(attr) {
      return attr === 'true' ? 'fal fa-angle-up' : 'fal fa-angle-down';
    },
    init: function init() {
      moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);

      if (this.startDate === null || this.endDate === null) {
        var times = getTimeArrayFromRangeKey(this.initialRange);
        this.startDate = this.startDate || (this.allowNull ? null : times[0]);
        this.endDate = this.endDate || (this.allowNull ? null : times[1]);
      }
    },
    getIsoDateStringFromUnix: function getIsoDateStringFromUnix(unixTimestamp) {
      return moment(unixTimestamp * 1000).format('YYYY-MM-DD');
    },
    getUnixFromIsoDate: function getUnixFromIsoDate(isoDateString) {
      return moment(new Date(isoDateString)).unix();
    },
    getUnixFromLocaleDate: function getUnixFromLocaleDate(dateLocaleString) {
      return moment(dateLocaleString, this.dateOnly ? 'll' : 'lll', this.getLocale()).unix();
    },
    getLocale: function getLocale() {
      return this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language;
    },
    getLocaleDateFromUnix: function getLocaleDateFromUnix(unixTimestamp) {
      if (unixTimestamp === null) {
        return '';
      }

      return moment(unixTimestamp * 1000).locale(this.getLocale()).format(this.dateOnly ? 'll' : 'lll');
    },
    handleQuickRangeClick: function handleQuickRangeClick(rangeKey, soFar, count, text) {
      var times = getTimeArrayFromRangeKey(rangeKey, soFar);
      this.startDate = times[0];
      this.endDate = times[1];
      this.pickedDisplayText = text;
      this.handleApplyClick();
    },
    handleApplyClick: function handleApplyClick() {
      this.$emit('date:picked', {
        from: this.startDate,
        to: this.isRange ? this.endDate : undefined
      });
      this.expanded = [];
      this.hideAlternateText = true;
    },
    validateInputDate: function validateInputDate(inputDate) {
      var inputTS = isNaN(inputDate) ? this.getUnixFromLocaleDate(inputDate) : inputDate;
      return moment(inputTS * 1000).isValid();
    },
    validateInputRange: function validateInputRange() {
      var startDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.startDate;
      var endDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.endDate;

      // ignore rangecheck if component is not working with time ranges
      if (!this.isRange) {
        return true;
      }

      var startTS = isNaN(startDate) ? this.getUnixFromLocaleDate(startDate) : startDate;
      var endTS = isNaN(endDate) ? this.getUnixFromLocaleDate(endDate) : endDate;
      return moment(startTS * 1000).isBefore(endTS * 1000);
    }
  }
};